module.exports = __webpack_public_path__ + "media/images/home/demo_right-961992a4d5264eca8f48b889cc459aac.png";